import React from "react";

import { Check } from "lucide-react";

import { cn } from "../../../lib/utils";
import { automationTestIds } from "../../../testing/automationTestIds";

const statusFor = (index, currentIndex) => {
  if (currentIndex > index) return "completed";
  if (currentIndex === index) return "active";
  return "upcoming";
};

const OnboardingStepper = ({ steps, currentStep, ariaLabel }) => (
  <div className="flex justify-center">
    <ol
      id={automationTestIds.onboardingStepper}
      aria-label={ariaLabel}
      className="inline-flex max-w-full items-center gap-2 overflow-x-auto px-1 py-1 sm:gap-3"
    >
      {steps.map((step, index) => {
        const status = statusFor(index, currentStep);
        const isHighlighted = status === "active" || status === "completed";

        return (
          <li
            key={step.id}
            className="flex items-center gap-2 sm:gap-3 shrink-0"
            data-step-id={step.id}
            data-step-status={status}
            aria-current={status === "active" ? "step" : undefined}
          >
            <span
              className={cn(
                "flex items-center justify-center w-7 h-7 rounded-full text-xs font-semibold transition-colors duration-300",
                isHighlighted
                  ? "bg-cfPrimaryButton text-white"
                  : "border-[1px] border-cfInactiveSurface bg-cfSecondary text-cfTextBreadcrumbDisabled",
              )}
            >
              {status === "completed" ? (
                <Check
                  className="w-4 h-4"
                  strokeWidth={2.5}
                  aria-hidden="true"
                />
              ) : (
                index + 1
              )}
            </span>
            <span
              className={cn(
                "text-sm whitespace-nowrap transition-colors duration-300",
                isHighlighted
                  ? "font-semibold text-cfHeadingText"
                  : "font-medium text-cfTextBreadcrumbDisabled",
                status !== "active" && "[@media(max-width:767px)]:hidden",
              )}
            >
              {step.label}
            </span>
            {index < steps.length - 1 ? (
              <span
                aria-hidden="true"
                className="ml-1 sm:ml-2 h-px w-4 sm:w-10 bg-cfInactiveSurface"
              />
            ) : null}
          </li>
        );
      })}
    </ol>
  </div>
);

export default OnboardingStepper;
